import { cloneDeep } from 'lodash';
import moment from 'moment';

class PropertyDetailsController {
    constructor($state, integrationApiService, propertiesService, messageService, access) {
        this.$state = $state;
        this.integrationApiService = integrationApiService;
        this.propertiesService = propertiesService;
        this.messageService = messageService;
        this.access = access;
    }

    $onInit () {
        this.details = this.property[this.type] || {};

        this.formatDate('expected_go_live');
        this.formatDate('go_live');

        if (this.property.integration && this.property.integration.import_run && !this.logs) {
            let type;
            switch (this.property.property_type) {
                case 'premier':
                    type = 'Core';
                    break;

                case 'concept':
                    type = 'Concept';
                    break;
            }

            this.integrationApiService.getImportLogs(this.property.id, type).then(response => {
                this.logs = response;
            });
        }
    }

    onSave () {
        this.formatDate('expected_go_live');
        this.formatDate('go_live');

        let preSubmission = cloneDeep(this.details);

        return this.propertiesService.updateDetails(this.details, this.property.id, this.type)
            .then(() => {
                this.messageService.success(`The ${this.type} details for <strong>${this.property.name}</strong> were successfully updated!`);
                this.formTab = 'property';
                this.property[this.type] = preSubmission;
                this.messageService.push();
                this.messageService.autoClear();
            })
            .catch((error) => {
                this.messageService.failure(`The ${this.type} details for <strong>${this.property.name}</strong> could not be successfully updated: ${error.statusText}`);
                this.messageService.push();
            });
    }

    formatDate (detailsField) {
        if (this.details[detailsField]) {
            if (!moment.isMoment(this.details[detailsField])) {
                this.details[detailsField] = moment(this.details[detailsField]);
                return;
            }

            this.details[detailsField] = this.details[detailsField].format('YYYY-MM-DD');
            return;
        }

        this.details[detailsField] = '';
    }
}

PropertyDetailsController.$inject = ['$state', 'integrationApiService', 'propertiesService', 'messageService', 'access'];

export default PropertyDetailsController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/property.details.controller.js